<div class="page-wrapper">
  <div class="page-header-with-back" style="display: flex; align-items: center; gap: 15px; margin-bottom: 24px;">
    <button type="button" class="form-back-btn" (click)="goBack()"
      style="background: white; border: 1px solid #eaeaea; font-size: 18px; cursor: pointer; color: #0a376e; display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 8px; transition: all 0.3s ease; box-shadow: 0 2px 4px rgba(0,0,0,0.02);">
      <i class="bi" [ngClass]="userLang === 'ar' ? 'bi-chevron-right' : 'bi-chevron-left'"></i>
    </button>
    <div class="page-title" style="margin-bottom: 0;">{{ (isEditMode ? 'addJob.editTitle' : 'addJob.createTitle') |
      translate }}</div>
  </div>

  <form [formGroup]="form">

    <!-- ══ Job Basics ══ -->
    <div class="section-card">
      <div class="section-header" (click)="toggleSection('basics')">
        <div class="section-header-left">
          <div class="section-icon basics-icon">
            <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="2" width="6" height="6" rx="1.5" fill="#3B6DD8" />
              <rect x="10" y="2" width="6" height="6" rx="1.5" fill="#3B6DD8" />
              <rect x="2" y="10" width="6" height="6" rx="1.5" fill="#3B6DD8" />
              <rect x="10" y="10" width="6" height="6" rx="1.5" fill="#3B6DD8" />
            </svg>
          </div>
          <span>{{ 'addJob.jobBasics' | translate }}</span>
        </div>
        <svg class="chevron" [class.open]="sections['basics']" viewBox="0 0 12 8" fill="none">
          <path d="M1 1l5 5 5-5" stroke="#8a92a6" stroke-width="1.5" stroke-linecap="round" />
        </svg>
      </div>

      <div class="section-body" *ngIf="sections['basics']">

        <!-- ROW 1: Job Post name + Post type -->
        <div class="form-row two-cols">
          <div class="field-group">
            <label class="field-label">{{ 'addJob.jobPostName' | translate }}</label>
            <input class="form-input" formControlName="jobPostName" [placeholder]="'addJob.jobPostName' | translate" type="text" />
          </div>
          <div class="field-group">
            <label class="field-label">{{ 'addJob.postType' | translate }}</label>
            <div class="radio-group post-type-group">
              <label class="radio-option post-type-option" *ngFor="let pt of data.postTypes">
                <input type="radio" formControlName="postType" [value]="pt.value" class="post-type-input" />
                <span class="radio-dot" [class.active]="form.get('postType')?.value === pt.value"></span>
                <span>{{ pt.label }}</span>
              </label>
            </div>
          </div>
        </div>

        <!-- ROW 2: Job Position + Job Level -->
        <div class="form-row two-cols">
          <div class="field-group">
            <label class="field-label">{{ 'addJob.jobPosition' | translate }}</label>
            <input class="form-input" formControlName="jobPosition" [placeholder]="'addJob.positionTitlePh' | translate" type="text" />
          </div>
          <div class="field-group">
            <label class="field-label">{{ 'addJob.jobLevel' | translate }}</label>
            <div class="custom-select" [class.open]="openDropdowns['careerLevel']">
              <div class="custom-select-trigger form-input" (click)="toggleDropdown('careerLevel', $event)">
                <span [class.select-placeholder]="!form.get('careerLevel')?.value">{{ getCareerLevelLabel() }}</span>
                <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              <div class="custom-select-dropdown" *ngIf="openDropdowns['careerLevel']"
                (click)="$event.stopPropagation()">
                <div *ngFor="let level of data.careerLevels" class="custom-select-option"
                  [class.option-active]="form.get('careerLevel')?.value === level.value"
                  (click)="selectDropdownOption('careerLevel', level.value, $event)">
                  {{ level.label }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Job Category -->
        <div class="form-section">
          <label class="field-label">{{ 'addJob.jobCategory' | translate }}</label>
          <div class="tags-input-wrapper category-wrapper" (click)="focusCategoryInput()">
            <div class="tags-list">
              <span *ngFor="let cat of selectedCategories" class="skill-tag">
                {{ cat | translate }}
                <button type="button" class="tag-remove" (click)="removeCategory(cat)">×</button>
              </span>
              <input #categoryInputRef class="tags-input" [(ngModel)]="categoryInput"
                [ngModelOptions]="{standalone: true}" (keydown.enter)="addCategory(); $event.preventDefault()"
                (keydown.comma)="addCategory(); $event.preventDefault()" [placeholder]="'addJob.jobCategory' | translate" />
            </div>
          </div>
        </div>

        <!-- Skills -->
        <div class="form-section">
          <label class="field-label">{{ 'addJob.skillsTools' | translate }}</label>
          <div class="tags-input-wrapper" (click)="focusSkillInput()">
            <div class="tags-list">
              <span *ngFor="let skill of selectedSkills" class="skill-tag">
                {{ skill }}
                <button type="button" class="tag-remove" (click)="removeSkill(skill)">×</button>
              </span>
              <input #skillInputRef class="tags-input" [(ngModel)]="skillInput" [ngModelOptions]="{standalone: true}"
                (keydown.enter)="addSkill(); $event.preventDefault()"
                (keydown.comma)="addSkill(); $event.preventDefault()"
                [placeholder]="selectedSkills.length === 0 ? ('addJob.addSkillsPlaceholder' | translate) : ''" />
            </div>
          </div>
        </div>

        <!-- Job type chips -->
        <div class="form-section">
          <label class="section-label">{{ 'addJob.jobType' | translate }}</label>
          <div class="chip-group">
            <button type="button" *ngFor="let jt of data.jobTypes" class="chip"
              [class.chip-active]="isJobTypeSelected(jt)" (click)="toggleJobType(jt)">
              {{ jt | translate }}
              <span *ngIf="isJobTypeSelected(jt)" class="chip-check">✓</span>
            </button>
            <button type="button" class="chip-add">+</button>
          </div>
        </div>

        <!-- Workplace -->
        <div class="form-section">
          <label class="section-label">{{ 'addJob.workplace' | translate }}</label>
          <div class="chip-group-workplace">
            <button type="button" *ngFor="let wp of data.workplaces" class="chip chip-workplace"
              [class.chip-active]="isWorkplaceSelected(wp)" (click)="toggleWorkplace(wp)">
              {{ wp | translate }}
              <span *ngIf="isWorkplaceSelected(wp)" class="chip-check">✓</span>
            </button>
          </div>
        </div>

        <!-- Country + City / Governorate -->
        <div class="form-row two-cols">
          <div class="field-group">
            <label class="field-label">{{ 'addJob.country' | translate }}</label>
            <div class="custom-select" [class.open]="openDropdowns['country']">
              <div class="custom-select-trigger form-input" (click)="toggleDropdown('country', $event)">
                <span [class.select-placeholder]="!form.get('country')?.value">{{ form.get('country')?.value ?
                  (form.get('country')?.value | translate) : ('addJob.selectCountry' | translate) }}</span>
                <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              <div class="custom-select-dropdown" *ngIf="openDropdowns['country']" (click)="$event.stopPropagation()">
                <div *ngFor="let c of data.countries" class="custom-select-option"
                  [class.option-active]="form.get('country')?.value === c"
                  (click)="selectDropdownOption('country', c, $event)">
                  {{ c | translate }}
                </div>
              </div>
            </div>
          </div>
          <div class="field-group">
            <label class="field-label">{{ locationFieldLabel | translate }}</label>
            <div class="custom-select" [class.open]="openDropdowns['city']" [class.disabled]="!availableCities.length">
              <div class="custom-select-trigger form-input"
                (click)="!availableCities.length ? null : toggleDropdown('city', $event)">
                <span [class.select-placeholder]="!form.get('city')?.value">{{ form.get('city')?.value ?
                  (form.get('city')?.value | translate) : ('addJob.selectCityGovernorate' | translate) }}</span>
                <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              <div class="custom-select-dropdown" *ngIf="openDropdowns['city'] && availableCities.length"
                (click)="$event.stopPropagation()">
                <div *ngFor="let city of availableCities" class="custom-select-option"
                  [class.option-active]="form.get('city')?.value === city"
                  (click)="selectDropdownOption('city', city, $event)">
                  {{ city | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Collar type -->
        <div class="form-row two-cols">
          <div class="field-group">
            <label class="field-label">{{ 'addJob.collarType' | translate }}</label>
            <div class="custom-select" [class.open]="openDropdowns['jobTypeDropdown']">
              <div class="custom-select-trigger form-input" (click)="toggleDropdown('jobTypeDropdown', $event)">
                <span [class.select-placeholder]="!form.get('jobTypeDropdown')?.value">{{
                  form.get('jobTypeDropdown')?.value ? (form.get('jobTypeDropdown')?.value | translate) :
                  ('addJob.selectType' | translate) }}</span>
                <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              <div class="custom-select-dropdown" *ngIf="openDropdowns['jobTypeDropdown']"
                (click)="$event.stopPropagation()">
                <div *ngFor="let jt of data.collar" class="custom-select-option"
                  [class.option-active]="form.get('jobTypeDropdown')?.value === jt"
                  (click)="selectDropdownOption('jobTypeDropdown', jt, $event)">
                  {{ jt | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- ══ Salary & Compensation ══ -->
    <div class="section-card">
      <div class="section-header" (click)="toggleSection('salary')">
        <div class="section-header-left">
          <div class="section-icon">
            <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="9" cy="9" r="7" stroke="#3B6DD8" stroke-width="1.5" />
              <path d="M9 5.5v7M7 8h3.5a1.5 1.5 0 010 3H7" stroke="#3B6DD8" stroke-width="1.3" stroke-linecap="round" />
            </svg>
          </div>
          <span>{{ 'addJob.salaryCompensation' | translate }}</span>
        </div>
        <svg class="chevron" [class.open]="sections['salary']" viewBox="0 0 12 8" fill="none">
          <path d="M1 1l5 5 5-5" stroke="#8a92a6" stroke-width="1.5" stroke-linecap="round" />
        </svg>
      </div>

      <div class="section-body" *ngIf="sections['salary']">
        <div class="salary-grid">
          <div class="field-group">
            <label class="field-label">{{ 'addJob.currency' | translate }}</label>
            <div class="custom-select" [class.open]="openDropdowns['currency']">
              <div class="custom-select-trigger form-input" (click)="toggleDropdown('currency', $event)">
                <span [class.select-placeholder]="!form.get('currency')?.value">{{ form.get('currency')?.value ||
                  ('addJob.currency' | translate) }}</span>
                <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              <div class="custom-select-dropdown" *ngIf="openDropdowns['currency']" (click)="$event.stopPropagation()">
                <div *ngFor="let c of data.currencies" class="custom-select-option"
                  [class.option-active]="form.get('currency')?.value === c"
                  (click)="selectDropdownOption('currency', c, $event)">
                  {{ c }}
                </div>
              </div>
            </div>
          </div>
          <div class="field-group">
            <label class="field-label">{{ 'addJob.minimum' | translate }}</label>
            <input class="form-input" formControlName="salaryMin" placeholder="e.g. 6,000" type="number" />
          </div>
          <div class="field-group">
            <label class="field-label">{{ 'addJob.maximum' | translate }}</label>
            <input class="form-input" formControlName="salaryMax" placeholder="e.g. 12,000" type="number" />
          </div>
          <div class="field-group">
            <label class="field-label">{{ 'addJob.every' | translate }}</label>
            <div class="custom-select" [class.open]="openDropdowns['period']">
              <div class="custom-select-trigger form-input" (click)="toggleDropdown('period', $event)">
                <span [class.select-placeholder]="!form.get('period')?.value">{{ form.get('period')?.value ?
                  (form.get('period')?.value | translate) : ('addJob.period' | translate) }}</span>
                <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              <div class="custom-select-dropdown" *ngIf="openDropdowns['period']" (click)="$event.stopPropagation()">
                <div *ngFor="let p of data.periods" class="custom-select-option"
                  [class.option-active]="form.get('period')?.value === p"
                  (click)="selectDropdownOption('period', p, $event)">
                  {{ p | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="salary-toggle">
          <label class="toggle-label">
            <input type="checkbox" [(ngModel)]="hideSalary" [ngModelOptions]="{standalone: true}" />
            <span>{{ 'addJob.hideSalaryDesc' | translate }}</span>
          </label>
          <p class="toggle-hint">{{ 'addJob.hideSalaryHint' | translate }}</p>
        </div>
        <div class="form-section salary-details-section">
          <label class="field-label">{{ 'addJob.additionalSalaryDetails' | translate }}</label>
          <textarea class="form-input form-textarea salary-details-textarea" rows="3"
            [(ngModel)]="additionalSalaryDetails" [ngModelOptions]="{standalone: true}"
            [placeholder]="'addJob.additionalSalaryDetailsPlaceholder' | translate"></textarea>
        </div>
      </div>
    </div>

    <!-- ══ About The Job ══ -->
    <div class="section-card">
      <div class="section-header" (click)="toggleSection('about')">
        <div class="section-header-left">
          <div class="section-icon">
            <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="3" width="14" height="2.5" rx="1.2" fill="#3B6DD8" />
              <rect x="2" y="7.75" width="10" height="2.5" rx="1.2" fill="#3B6DD8" />
              <rect x="2" y="12.5" width="12" height="2.5" rx="1.2" fill="#3B6DD8" />
            </svg>
          </div>
          <span>{{ 'addJob.aboutJob' | translate }}</span>
        </div>
        <svg class="chevron" [class.open]="sections['about']" viewBox="0 0 12 8" fill="none">
          <path d="M1 1l5 5 5-5" stroke="#8a92a6" stroke-width="1.5" stroke-linecap="round" />
        </svg>
      </div>

      <div class="section-body" *ngIf="sections['about']">

        <div class="form-section">
          <label class="field-label">{{ 'addJob.jobDescription' | translate }}</label>
          <div class="quill-wrapper">
            <div id="jobDescEditor"></div>
          </div>
        </div>

        <div class="form-section">
          <label class="field-label">{{ 'addJob.requirements' | translate }}</label>
          <p class="field-hint">{{ 'addJob.requirementsHint' | translate }}</p>
          <div class="quill-wrapper quill-simple">
            <div id="requirementsEditor"></div>
          </div>
        </div>

        <div class="form-section">
          <label class="field-label">
            {{ 'addJob.responsibilities' | translate }}
            <span class="optional-badge">{{ 'addJob.optional' | translate }}</span>
          </label>
          <div class="quill-wrapper quill-simple">
            <div id="responsibilitiesEditor"></div>
          </div>
        </div>
        <div class="form-section">
          <label class="field-label">
            {{ 'addJob.benefits' | translate }}
            <span class="optional-badge">{{ 'addJob.optional' | translate }}</span>
          </label>
          <div class="quill-wrapper quill-simple">
            <div id="benefitsEditor"></div>
          </div>
        </div>

        <div class="form-section">
          <label class="section-label">{{ 'addJob.yearsExperience' | translate }}</label>
          <div class="range-row">
            <div class="custom-select range-select" [class.open]="openDropdowns['expMin']">
              <div class="custom-select-trigger form-input" (click)="toggleDropdown('expMin', $event)">
                <span [class.select-placeholder]="!form.get('expMin')?.value">{{ form.get('expMin')?.value === 'Min' ?
                  ('addJob.min' | translate) : form.get('expMin')?.value }}</span>
                <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              <div class="custom-select-dropdown" *ngIf="openDropdowns['expMin']" (click)="$event.stopPropagation()">
                <div class="custom-select-option" [class.option-active]="form.get('expMin')?.value === 'Min'"
                  (click)="selectDropdownOption('expMin', 'Min', $event)">{{ 'addJob.min' | translate }}</div>
                <div *ngFor="let y of data.experienceYears" class="custom-select-option"
                  [class.option-active]="form.get('expMin')?.value === y"
                  (click)="selectDropdownOption('expMin', y, $event)">
                  {{ y }}
                </div>
              </div>
            </div>
            <span class="range-sep">{{ 'addJob.to' | translate }}</span>
            <div class="custom-select range-select" [class.open]="openDropdowns['expMax']">
              <div class="custom-select-trigger form-input" (click)="toggleDropdown('expMax', $event)">
                <span [class.select-placeholder]="!form.get('expMax')?.value">{{ form.get('expMax')?.value === 'Max' ?
                  ('addJob.max' | translate) : form.get('expMax')?.value }}</span>
                <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              <div class="custom-select-dropdown" *ngIf="openDropdowns['expMax']" (click)="$event.stopPropagation()">
                <div class="custom-select-option" [class.option-active]="form.get('expMax')?.value === 'Max'"
                  (click)="selectDropdownOption('expMax', 'Max', $event)">{{ 'addJob.max' | translate }}</div>
                <div *ngFor="let y of data.experienceYears" class="custom-select-option"
                  [class.option-active]="form.get('expMax')?.value === y"
                  (click)="selectDropdownOption('expMax', y, $event)">
                  {{ y }}
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- ══ Application Settings ══ -->
    <div class="section-card">
      <div class="section-header" (click)="toggleSection('appSettings')">
        <div class="section-header-left">
          <div class="section-icon">
            <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="9" cy="9" r="7" stroke="#3B6DD8" stroke-width="1.5" />
              <path d="M9 5.5v4l2.5 2" stroke="#3B6DD8" stroke-width="1.3" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
          <span>{{ 'addJob.applicationSettings' | translate }}</span>
        </div>
        <svg class="chevron" [class.open]="sections['appSettings']" viewBox="0 0 12 8" fill="none">
          <path d="M1 1l5 5 5-5" stroke="#8a92a6" stroke-width="1.5" stroke-linecap="round" />
        </svg>
      </div>

      <div class="section-body" *ngIf="sections['appSettings']">

        <div class="app-settings-grid">
          <div class="field-group">
            <label class="field-label">{{ 'addJob.applicationMethod' | translate }}</label>
            <div class="custom-select" [class.open]="openDropdowns['appMethod']">
              <div class="custom-select-trigger form-input" (click)="toggleDropdown('appMethod', $event)">
                <span [class.placeholder]="!selectedAppMethod">{{ getAppMethodLabel() | translate }}</span>
                <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              <div class="custom-select-dropdown" *ngIf="openDropdowns['appMethod']" (click)="$event.stopPropagation()">
                <div class="custom-select-option" [class.option-active]="selectedAppMethod === 'platform'"
                  (click)="selectMethodOption('platform', $event)">{{ 'Upload CV (Platform)' | translate }}</div>
                <div class="custom-select-option" [class.option-active]="selectedAppMethod === 'external'"
                  (click)="selectMethodOption('external', $event)">{{ 'External link' | translate }}</div>
              </div>
            </div>
            <div *ngIf="selectedAppMethod === 'external'" class="external-link-field">
              <input class="form-input" [(ngModel)]="externalLink" [ngModelOptions]="{standalone: true}"
                placeholder="https://example.com/apply" />
            </div>
          </div>
          <div class="field-group">
            <label class="field-label">{{ 'addJob.deadline' | translate }}</label>
            <input class="form-input" type="date" [(ngModel)]="applicationDeadline"
              [ngModelOptions]="{standalone: true}" placeholder="mm/dd/yyyy" />
          </div>
          <div class="field-group">
            <label class="field-label">
              {{ 'addJob.maxApplicants' | translate }}
              <span class="optional-badge">{{ 'addJob.optional' | translate }}</span>
            </label>
            <input class="form-input" [(ngModel)]="maxApplicants" [ngModelOptions]="{standalone: true}"
              [placeholder]="'addJob.noLimit' | translate" />
          </div>
        </div>

        <div class="form-section">
          <label class="field-label">
            {{ 'addJob.addQuestions' | translate }}
            <span class="optional-badge">{{ 'addJob.optional' | translate }}</span>
          </label>
          <div *ngFor="let q of questions; let i = index; trackBy: trackByIndex" class="question-row"
            [class.question-row-disabled]="questionsDisabled">
            <span class="q-num">{{ i + 1 }}-</span>
            <input class="form-input" [(ngModel)]="questions[i].question" [ngModelOptions]="{standalone: true}"
              [disabled]="questionsDisabled" [placeholder]="'addJob.question' | translate" />
            <label class="question-required">
              <input type="checkbox" [(ngModel)]="questions[i].required" [ngModelOptions]="{standalone: true}"
                [disabled]="questionsDisabled" />
              <span>{{ 'addJob.required' | translate }}</span>
            </label>
            <button *ngIf="questions.length > 1" type="button" class="q-remove" (click)="removeQuestion(i)"
              [disabled]="questionsDisabled">×</button>
          </div>
          <button type="button" class="add-question-btn" (click)="addQuestion()" [disabled]="questionsDisabled">
            {{ 'addJob.addQuestionBtn' | translate }}
          </button>
        </div>

      </div>
    </div>

    <!-- ══ Job Visibility & Settings ══ -->
    <div class="section-card">
      <div class="section-header" (click)="toggleSection('visibility')">
        <div class="section-header-left">
          <div class="section-icon">
            <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <ellipse cx="9" cy="9" rx="7" ry="5" stroke="#3B6DD8" stroke-width="1.5" />
              <circle cx="9" cy="9" r="2.5" fill="#3B6DD8" />
            </svg>
          </div>
          <span>{{ 'addJob.jobVisibility' | translate }}</span>
          <span class="premium-badge">
            <svg width="13" height="13" viewBox="0 0 14 14" fill="none">
              <rect x="1" y="5" width="12" height="8" rx="2" stroke="#e8392a" stroke-width="1.4" />
              <path d="M5 5V4a2 2 0 014 0v1" stroke="#e8392a" stroke-width="1.4" stroke-linecap="round" />
            </svg>
            {{ 'addJob.premiumFeatures' | translate }}
          </span>
        </div>
        <svg class="chevron" [class.open]="sections['visibility']" viewBox="0 0 12 8" fill="none">
          <path d="M1 1l5 5 5-5" stroke="#8a92a6" stroke-width="1.5" stroke-linecap="round" />
        </svg>
      </div>

      <div class="section-body" *ngIf="sections['visibility']">
        <div class="visibility-grid">

          <!-- ── Confidential Post ── -->
          <div class="vis-card" [class.vis-card-active]="isConfidential" [class.vis-card-locked]="hasAnyPremiumLocked">
            <div class="vis-card-top">
              <div>
                <div class="vis-title-row">
                  <span class="vis-title">{{ 'addJob.confidentialPost' | translate }}</span>

                </div>
                <p class="vis-sub" *ngIf="!confidentialLocked">{{ 'addJob.confidentialDesc' | translate }}</p>
                <p class="vis-sub" *ngIf="confidentialLocked">
                  {{ 'addJob.activeUntil' | translate }} {{ getExpiryLabel(confidentialExpiresAt) }}
                </p>
              </div>
              <button type="button" class="toggle-switch" [class.on]="isConfidential" [disabled]="hasAnyPremiumLocked"
                (click)="toggleConfidential()"></button>
            </div>
            <div class="vis-price">
              <span class="vis-price-amount">{{ selectedConfidentialPlan.price }}</span>
              <span class="vis-price-currency">EGP</span>
            </div>

            <!-- Duration picker — shown only when Confidential is ON -->
            <div class="duration-picker" *ngIf="isConfidential || confidentialLocked">
              <button type="button" *ngFor="let plan of confidentialPlans" class="duration-btn"
                [class.duration-btn-active]="selectedConfidentialPlan.days === plan.days"
                [disabled]="hasAnyPremiumLocked" (click)="selectConfidentialPlan(plan)">
                <span class="duration-days">{{ plan.days }} {{ (plan.days > 1 ? 'Days' : 'Day') | translate }}</span>
                <span class="duration-price">{{ plan.price }} EGP</span>
              </button>
            </div>
          </div>

          <!-- ── Featured Job ── -->
          <div class="vis-card" [class.vis-card-active]="isFeatured" [class.vis-card-locked]="hasAnyPremiumLocked">
            <div class="vis-card-top">
              <div>
                <div class="vis-title-row">
                  <span class="vis-title">{{ 'addJob.featuredJob' | translate }}</span>
                  <span class="recommended-badge">★ {{ 'addJob.recommended' | translate }}</span>
                </div>
                <p class="vis-sub" *ngIf="!featuredLocked">{{ 'addJob.featuredDesc' | translate }}</p>
                <p class="vis-sub" *ngIf="featuredLocked">
                  {{ 'addJob.activeUntil' | translate }} {{ getExpiryLabel(featuredExpiresAt) }}
                </p>
              </div>
              <button type="button" class="toggle-switch" [class.on]="isFeatured" [disabled]="hasAnyPremiumLocked"
                (click)="toggleFeatured()"></button>
            </div>
            <div class="vis-price">
              <span class="vis-price-amount">{{ selectedFeaturedPlan.price }}</span>
              <span class="vis-price-currency">EGP</span>
            </div>

            <!-- Duration picker — shown only when Featured is ON -->
            <div class="duration-picker" *ngIf="isFeatured || featuredLocked">
              <button type="button" *ngFor="let plan of featuredPlans" class="duration-btn"
                [class.duration-btn-active]="selectedFeaturedPlan.days === plan.days" [disabled]="hasAnyPremiumLocked"
                (click)="selectFeaturedPlan(plan)">
                <span class="duration-days">{{ plan.days }} {{ (plan.days > 1 ? 'Days' : 'Day') | translate }}</span>
                <span class="duration-price">{{ plan.price }} EGP</span>
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- ══ Confirmation Modal ══ -->
    <div class="modal-backdrop" *ngIf="showConfirmModal" (click)="closeConfirmModal()">
      <div class="modal-card" (click)="$event.stopPropagation()">
        <h2 class="modal-title">{{ 'addJob.confirmPromotionTitle' | translate }}</h2>
        <p class="modal-subtitle">{{ 'addJob.confirmPromotionSub' | translate }}</p>

        <div class="modal-items">

          <!-- Featured Job row -->
          <div class="modal-item" *ngIf="isFeatured && !featuredLocked">
            <div class="modal-item-icon modal-item-icon--star">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 1l1.8 3.6L14 5.4l-3 2.9.7 4.1L8 10.4l-3.7 1.9.7-4.1-3-2.9 4.2-.8z" fill="#e8392a"
                  stroke="#e8392a" stroke-width="0.5" />
              </svg>
            </div>
            <div class="modal-item-info">
              <span class="modal-item-name">{{ 'addJob.featuredJob' | translate }}</span>
              <span class="modal-item-desc">{{ 'addJob.featuredDesc' | translate }}</span>
              <span class="modal-item-duration">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <circle cx="6" cy="6" r="5" stroke="#3B6DD8" stroke-width="1.2" />
                  <path d="M6 3v3l2 1.5" stroke="#3B6DD8" stroke-width="1.2" stroke-linecap="round" />
                </svg>
                {{ 'addJob.duration' | translate }}: {{ selectedFeaturedPlan.days }} {{ (selectedFeaturedPlan.days > 1 ?
                'Days' : 'Day') | translate }}
              </span>
            </div>
            <span class="modal-item-price">{{ selectedFeaturedPlan.price }} EGP</span>
          </div>

          <!-- Confidential Post row -->
          <div class="modal-item" *ngIf="isConfidential && !confidentialLocked">
            <div class="modal-item-icon modal-item-icon--lock">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <rect x="3" y="7" width="10" height="7" rx="1.5" stroke="#8a92a6" stroke-width="1.4" />
                <path d="M5 7V5a3 3 0 016 0v2" stroke="#8a92a6" stroke-width="1.4" stroke-linecap="round" />
              </svg>
            </div>
            <div class="modal-item-info">
              <span class="modal-item-name">{{ 'addJob.confidentialPost' | translate }}</span>
              <span class="modal-item-desc">{{ 'addJob.confidentialDesc' | translate }}</span>
              <span class="modal-item-duration">
                {{ 'addJob.duration' | translate }}: {{ selectedConfidentialPlan.days }} {{
                (selectedConfidentialPlan.days > 1 ? 'Days' : 'Day') | translate }}
              </span>
            </div>
            <span class="modal-item-price">{{ selectedConfidentialPlan.price }} EGP</span>
          </div>

        </div>

        <div class="modal-divider"></div>

        <div class="modal-total-row">
          <span class="modal-total-label">{{ 'addJob.total' | translate }}</span>
          <span class="modal-total-amount">{{ modalTotal }} EGP</span>
        </div>

        <p class="modal-charge-note">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <circle cx="7" cy="7" r="6" stroke="#e8392a" stroke-width="1.2" />
            <path d="M7 4v3.5" stroke="#e8392a" stroke-width="1.4" stroke-linecap="round" />
            <circle cx="7" cy="10" r="0.8" fill="#e8392a" />
          </svg>
          {{ 'addJob.chargeNote' | translate }}
        </p>

        <div class="modal-actions">
          <button type="button" class="modal-btn-cancel" (click)="closeConfirmModal()">{{ 'common.cancel' | translate
            }}</button>
          <button type="button" class="modal-btn-confirm" (click)="confirmPromotion()">
            {{ 'addJob.confirmPayBtn' | translate }} {{ modalTotal }} EGP →
          </button>
        </div>
      </div>
    </div>

    <!-- ══ Publish / Draft actions ══ -->
    <div class="publish-actions">
      <button type="button" class="draft-btn" *ngIf="canMoveToDraft" (click)="submitForm('DRAFT')">
        {{ 'addJob.moveToDraft' | translate }}
      </button>

      <button type="button" class="publish-btn" (click)="submitForm('PUBLISHED')">
        {{ primaryActionLabelKey | translate }}
      </button>
    </div>

  </form>
</div>